<ng-container *ngIf="context">
  <p class="contact">{{ context.row[context.id] }}</p>
  <div class="notification-settings">
    <app-badge *ngFor="let badge of badges" [badge]="badge" [tooltipLabel]="badge.key"></app-badge>
  </div>
</ng-container>
